import { Case, CaseDetails } from '__generated__/api-di';
import { http } from '../http';

type ApplicationdataDetailsId = {
  commercialLabel: string;
  loanNumberExternal: number;
  applicationIndexNumber: number;
};

export async function getCasesData(commercialRelation: string | null): Promise<Case[]> {
  const url = `/api/v1/cases/commercialrelation/${commercialRelation}`;
  const response = await http.get<Case[]>(url);
  return response.data;
}

export async function getAllCases(): Promise<Case[]> {
  const url = '/api/v1/cases';
  const response = await http.get<Case[]>(url);
  return response.data;
}

export async function getCaseDetails(id: ApplicationdataDetailsId): Promise<CaseDetails> {
  const { commercialLabel, loanNumberExternal, applicationIndexNumber } = id;
  const url = `/api/v1/lenders/${commercialLabel}/cases/${loanNumberExternal}-${applicationIndexNumber}`;

  const response = await http.get<CaseDetails>(url);
  return response.data;
}

export async function getASRCaseDetails(id: number): Promise<any> {
  const url = `/applicationregistration/${id}`;
  const response = await http.get(url);
  return response.data;
}

export async function updateAsrCasesDetails(asrDetails: any) {
  try {
    const response = await http({
      url: '/applicationregistration',
      method: 'POST',
      data: JSON.stringify(asrDetails),
    });
    return { data: response.data, status: 200 };
  } catch (err: any) {
    const {
      response: { status },
    } = err;
    return { status: status };
  }
}

export async function sendAsrApplicationEx(formData: any) {
  const url = '/applicationregistration/submit';
  try {
    const response = await http.post<{}>(url, JSON.stringify(formData), {
      headers: {
        Accept: '*/*',
      },
    });
    return { data: response.data, status: 200 };
  } catch (err: any) {
    const {
      response: { status },
    } = err;
    return { status: status };
  }
}
